import section from "fragments/section"
import gql from "graphql-tag"

const GET_SECTION = gql`
  ${section}

  query section($id: ID!, $updatedAt: String) {
    section(id: $id, updatedAt: $updatedAt) {
      ...Section
    }
  }
`
export default GET_SECTION
